import React, { useCallback } from "react"
import { CardFormaPagamentoProps } from "./card-forma-pagamento-props"
import { Button, Typography } from "@material-ui/core"
import { useStyles } from "./card-forma-pagamento-styles"
import { CartaoIcon } from "components/icons/cartao-icon"
import { BoletoIcon } from "components/icons/boleto-icon"
import { ChequeIcon } from "components/icons/cheque-icon"
import { CreditoLojaIcon } from "components/icons/credito-loja-icon"
import { DepositoBancarioIcon } from "components/icons/deposito-bancario-icon"
import { DinheiroIcon } from "components/icons/dinheiro-icon"
import { DuplicataMercantilIcon } from "components/icons/duplicata-mercantil-icon"
import { QrCodeIcon } from "components/icons/qr-code-icon"
import { CartaoFidelidadeIcon } from "components/icons/cartao-fidelidade-icon"
import { SemDinheiroIcon } from "components/icons/sem-dinheiro-icon"
import { TransferenciaBancariaIcon } from "components/icons/transferencia-bancaria-icon"
import { ValeAlimentacaoIcon } from "components/icons/vale-alimentacao-icon"
import { ValeCombustivelIcon } from "components/icons/vale-combustivel-icon"
import { ValePresenteIcon } from "components/icons/vale-presente-icon"
import { POSIcon } from "components/icons/pos-icon"
import { EnumPagTpMod } from "models/enums/enum-pag-tpmod"

export const CardFormaPagamento = ({ model, onClick }: CardFormaPagamentoProps) => {
    const classes = useStyles()

    const cardIcon = useCallback(() => {
        switch (model.tpMod) {
            case EnumPagTpMod.BOLETO_BANCARIO:
                return <BoletoIcon tipo="BUTTON" />;
            case EnumPagTpMod.CARTAO_CREDITO:
            case EnumPagTpMod.CARTAO_DEBITO:
                return <CartaoIcon tipo="BUTTON" />;
            case EnumPagTpMod.CHEQUE:
                return <ChequeIcon tipo="BUTTON" />;
            case EnumPagTpMod.CREDITO_LOJA:
                return <CreditoLojaIcon tipo="BUTTON" />;
            case EnumPagTpMod.DEPOSITO_BANCARIO:
                return <DepositoBancarioIcon tipo="BUTTON" />;
            case EnumPagTpMod.DINHEIRO:
                return <DinheiroIcon tipo="BUTTON" />;
            case EnumPagTpMod.DUPLICATA_MERCANTIL:
                return <DuplicataMercantilIcon tipo="BUTTON" />;
            case EnumPagTpMod.PAGAMENTO_INSTANTANEO:
                return <QrCodeIcon tipo="BUTTON" />;
            case EnumPagTpMod.PROGRAMA_FIDELIDADE:
                return <CartaoFidelidadeIcon tipo="BUTTON" />;
            case EnumPagTpMod.SEM_PAGAMENTO:
                return <SemDinheiroIcon tipo="BUTTON" />;
            case EnumPagTpMod.TRANSFERENCIA_BANCARIA:
                return <TransferenciaBancariaIcon tipo="BUTTON" />;
            case EnumPagTpMod.VALE_ALIMENTACAO:
            case EnumPagTpMod.VALE_REFEICAO:
                return <ValeAlimentacaoIcon tipo="BUTTON" />;
            case EnumPagTpMod.VALE_COMBUSTIVEL:
                return <ValeCombustivelIcon tipo="BUTTON" />;
            case EnumPagTpMod.VALE_PRESENTE:
                return <ValePresenteIcon tipo="BUTTON" />;

            default:
                return <POSIcon tipo="BUTTON" />;
        }
    }, [model.tpMod]);

    return (
        <Button fullWidth size="large" className={classes.btn} variant="outlined" onClick={() => onClick(model)}>
            {cardIcon()}
            <Typography color="textPrimary" className={classes.title}>
                {model.descricao}
            </Typography>
        </Button>
    )
}